<template>
  <div class="c-list">
    <div class="c-list__hero">
      <div class="wrapper">
        <!-- Post Type Label -->
        <div class="post-type" v-if="fields && fields.postType">
          <sc-text v-if="fields && fields.postType" :field="fields.postType" />
        </div>

        <!-- Headline Placeholder -->
        <div class="post-headline" v-if="fields && fields.heading">
          <sc-text v-if="fields && fields.heading" :field="fields.heading" />
        </div>

        <!-- Navigation Placholder - passes postType -->
        <div class="post-navigation">
          <div class="post-navigation-container">
            <sc-placeholder
              name="jss-list-hero-link"
              :postType="fields.postType"
              :rendering="rendering"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Page-Hero',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  mounted() {
    const navContainer = document.querySelector('.post-navigation-container');

    if (navContainer && navigator && navigator.userAgentData && navigator.userAgentData.mobile) {
      const isMobile = navigator.userAgentData.mobile;

      if (isMobile) {
        navContainer.classList.add('touch-device');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.c-list {
  &__hero {
    width: 100%;
    @include padding-y(2.5rem);
    color: $white;
    background: linear-gradient(
      169deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 59, 92, 1) 20%,
      rgba(0, 134, 191, 1) 100%
    );

    @include desktop-up {
      @include padding-y(4rem, 2rem);
      overflow: hidden;
    }

    .wrapper {
      @include padding-x-thin;
    }

    .post-type {
      @include font-styles('Arial Narrow', 1.8rem, 600, normal, 2.2rem, normal, $white);
      text-transform: uppercase;
      margin-bottom: 2rem;
    }

    .post-headline {
      @include font-styles('Arial Narrow', 2rem, 200, normal, 2.4rem, normal, $white);
      @include margin-y(0, 3rem);

      @include desktop-up {
        font-size: 3.6rem;
        line-height: 4.2rem;
        margin-bottom: 4rem;
      }
    }

    .post-navigation {
      position: relative;
      padding-top: 2rem;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        height: 0.2rem;
        background-color: $white;
        opacity: 0.2;
      }

      &-container {
        overflow-x: auto;
        white-space: nowrap;
        position: relative;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}

.post-navigation-container:not(.touch-device) {
  padding-bottom: 0.5rem;

  * {
    scrollbar-width: thin;
  }

  &::-webkit-scrollbar {
    height: 0.5rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $gray;
    opacity: 0.5;
    border-radius: 1rem;
  }
}
</style>
